import gql from "graphql-tag";

export default gql`
  mutation StopRTMP($eventId: ID, $componentName: String) {
    stopRTMP(eventId: $eventId, componentName: $componentName) {
      id
    }
  }
`;
